'use es6';

export const createAsyncWidgetEditor = () => import( /* webpackPreload: true, webpackChunkName: 'AsyncWidgetEditor' */'InpageEditorUI/lib/createWidgetEditor');